import pick from 'lodash-es/pick';
export function useFormQuestionnaireProps(flow) {
  return {
    createSteps: [function questionnaireSteps(_ref) {
      let [step1] = _ref;
      return [step1.concat(['SELLPOINT', 'SELL_TYPES'])];
    }],

    /*
      TODO post mvp: create a better API to add questionnaires to the final payload, doing this way is leaking implementation details, the ideal API would be adding a questionnaires field to the carleadCreationForm object that exposes a updateQuestionnaires(name: string, answers: {[key: string]: string}): {[name]: {[key: string]: string}} function that will be called when parsing the values to payload and transform the return of this fn to a questionnaire array.
    */
    partialPayloadMappers: [function mapQuestionnaire(_ref2) {
      let {
        values,
        initialPayload: {
          questionnaires
        }
      } = _ref2;
      const index = questionnaires.findIndex(i => i.type === 'customerSurvey');
      const fields = Object.entries(flow).filter(_ref3 => {
        let [_, value] = _ref3;
        return value.nodeType === 'questionnaireField';
      }).map(_ref4 => {
        let [_, value] = _ref4;
        return value.name;
      });
      const questionnaireValues = pick(values, fields);
      const items = Object.entries(questionnaireValues) // remove empty selected questionnaire items
      .filter(_ref5 => {
        let [_, value] = _ref5;
        return value !== '' || value != null;
      }).map(_ref6 => {
        let [key, value] = _ref6;
        return {
          question: key,
          answer: value
        };
      });

      if (index !== -1) {
        questionnaires[index].questions.push(...items);
      } else {
        questionnaires.push({
          type: 'customerSurvey',
          questions: items
        });
      }

      return {
        questionnaires: questionnaires
      };
    }],
    createCustomValidators: [function questionnaireValidators(_ref7) {
      let {
        validators
      } = _ref7;
      return { ...validators,

        SELLPOINT(_ref8) {
          let {
            values,
            errorMessages
          } = _ref8;

          if (values.SELLPOINT == null || values.SELLPOINT === '') {
            return errorMessages.selectAnswer;
          }

          return true;
        },

        SELL_TYPES(_ref9) {
          let {
            values,
            errorMessages
          } = _ref9;

          if (values.SELLPOINT === 'SELLPOINT_NOT_PLANNED') {
            return true;
          }

          if (values.SELL_TYPES == null || values.SELL_TYPES === '') {
            return errorMessages.selectAnswer;
          }

          return true;
        }

      };
    }]
  };
}